import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, observable } from 'aurelia-framework';
import { getAutocompleteTypeFromProductSource } from 'elements/input-autocomplete-type';
import { NettingTypeService, ErpSystem } from 'models';
import { ErpSystemService } from 'services/erp-system-service';
import { ErrorService } from 'services/error-service';
import { MaterialService } from 'services/material-service';
import { MeshSizeService } from 'services/mesh-size-service';
import { NylonTypeService } from 'services/nylon-type-service';
import { ProductService } from 'services/product-service';
import { ThreadTypeService } from 'services/thread-type-service';

@autoinject
export class NettingTypeForm {
  @bindable
  @observable
  private nettingType: NettingTypeService;
  nettingTypeChanged(nettingType: NettingTypeService) {
    if (nettingType?.Id) {
      void this.setProductName(nettingType.ProductId);
    }
  }

  protected articleNo = '';
  protected isDuplicate = false;

  protected inputAutocompleteType: string = 'generalproduct';
  protected erpSystemSelected = false;
  protected erpSystems: ErpSystem[] = [];

  constructor(
    private productService: ProductService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    protected materialService: MaterialService,
    protected threadTypeService: ThreadTypeService,
    protected meshSizeService: MeshSizeService,
    protected nylonTypeService: NylonTypeService,
    private erpSystemService: ErpSystemService
  ) {
    void this.getErpSystems();
  }

  private attached() {
    this.eventAggregator.subscribe('nettingTypeServiceIsDuplicate', (isDuplicate) => {
      this.isDuplicate = isDuplicate;
    });
  }

  protected setProductId(event: { detail: { value: string } }) {
    const productId = Number(event.detail.value);
    this.nettingType.ProductId = productId;
    void this.setProductName(productId);
  }

  private async setProductName(productId: number) {
    try {
      if (productId) {
        const product = await this.productService.get(productId);
        this.nettingType.Name = product.Name;
        this.articleNo = product.ArticleNo;
      }
    } catch (error) {
      this.errorService.handleError(error);
    }
  }
  protected async getErpSystems() {
    this.erpSystems = await this.erpSystemService.getAll();
  }

  protected setErpSystem(erpSystemProductSource: string) {
    this.inputAutocompleteType = getAutocompleteTypeFromProductSource(erpSystemProductSource);
    this.erpSystemSelected = true;
  }
}
